import script from "./textListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./textListPage.vue?vue&type=script&setup=true&lang=js"

import "./textListPage.vue?vue&type=style&index=0&id=800c6398&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-800c6398"]])

export default __exports__